import { render } from "./refund.vue?vue&type=template&id=23bd4352&scoped=true"
import script from "./refund.vue?vue&type=script&lang=js"
export * from "./refund.vue?vue&type=script&lang=js"

import "./refund.vue?vue&type=style&index=0&id=23bd4352&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bd4352"],['__file',"src/views/ticket/order/refund.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23bd4352"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23bd4352', __exports__)) {
    console.log('reload')
    api.reload('23bd4352', __exports__)
  }
  
  module.hot.accept("./refund.vue?vue&type=template&id=23bd4352&scoped=true", () => {
    console.log('re-render')
    api.rerender('23bd4352', render)
  })

}


export default __exports__